export const card = "card";
export const sepa = "sepa_debit";
